import React from 'react'
import PropTypes from 'prop-types'
import AvatarLib from '@material-ui/core/Avatar'
import defaultTypes, { defaultPropTypes } from '../DefaultPropTypes'
import Icon from '../Icon'

function Avatar({ className, iconName, children }) {
  return (
    <AvatarLib className={className}>
      { children || <Icon iconName={iconName} />}
    </AvatarLib>
  )
}

Avatar.defaultProps = {
  ...defaultPropTypes,
}

Avatar.propTypes = {
  ...defaultTypes,
  iconName: PropTypes.string,
}

export default Avatar
